'use strict';

/**
 * Menu toggle
 */
document.querySelector('#sph-menu-open .sph-menu-button').addEventListener('click', function (event) {
  event.preventDefault();
  document.querySelector('#sitenav-container').classList.remove('close');
  document.querySelector('#sitenav-container').classList.add('open');
  return false;
});
document.querySelector('#sph-menu-close >div').addEventListener('click', function (event) {
  event.preventDefault();
  document.querySelector('#sitenav-container').classList.remove('open');
  document.querySelector('#sitenav-container').classList.add('close');
  return false;
});

/**
 * Header animation
 */
var headerAnimation = false;
document.addEventListener("scroll", function () {
  if (window.scrollY > window.innerWidth / 3) {
    headerAnimation = true;
    document.querySelector('header').classList.add('small');
    document.querySelector('header').classList.remove('full');
  }
  if (window.scrollY < window.innerWidth / 3 && headerAnimation === true) {
    document.querySelector('header').classList.add('full');
    document.querySelector('header').classList.remove('small');
  }
  return;
});

/**
 * Hero slider
 */
console.log();
if (document.querySelector('#hero-slider') !== null) {
  /* global Swiper */
  var swiper = new Swiper('#hero-slider .swiper', {
    slidesPerView: 1,
    pagination: {
      el: '#hero-slider .swiper .swiper-pagination',
      type: 'bullets'
    }
  });
}

/**
 * Scroll-top
 */
document.querySelector('#to-top').addEventListener('click', function (event) {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
  return false;
});